export const finderTxUrl = (network: string, txHash: string) =>
  `https://finder.terra.money/${network}/tx/${txHash}`;
